import React from 'react';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Link as MuiLink } from '@mui/material';
import { useParams, Link } from 'react-router-dom';

const AreaDetails = () => {
  const { areaId } = useParams();
  
  const getProjectIdFromShipName = (shipName) => {
    const projectMap = {
      'Ship Alpha': '1',
      'Ship Beta': '2', 
      'Ship Gamma': '3'
    };
    return projectMap[shipName] || '1';
  };
  
  const parseUnitString = (unitString) => {
    const parts = unitString.split(' - ');
    return {
      unitName: parts[0],
      shipName: parts[1],
      projectId: getProjectIdFromShipName(parts[1])
    };
  };
  
  const generateUnits = () => {
    const ships = ['Ship Alpha', 'Ship Beta', 'Ship Gamma'];
    const units = [];
    for (let i = 10; i <= 50; i++) {
      const randomShip = ships[Math.floor(Math.random() * ships.length)];
      units.push(`UNIT${i} - ${randomShip}`);
    }
    return units;
  };
  
  const allAreas = {
    dock1: { name: 'Dock 1', units: generateUnits().slice(0, 3) },
    dock2: { name: 'Dock 2', units: generateUnits().slice(3, 5) },
    dock3: { name: 'Dock 3', units: generateUnits().slice(5, 7) },
    welding: { name: 'Welding Shop', units: generateUnits().slice(7, 9) },
    assembly: { name: 'Assembly Hall', units: generateUnits().slice(9, 12) },
    paint: { name: 'Paint Shop', units: generateUnits().slice(12, 14) },
    storage: { name: 'Storage', units: generateUnits().slice(14, 15) },
    office: { name: 'Office', units: [] },
    crane: { name: 'Crane Rail', units: [] },
    harbor: { name: 'Harbor Water', units: generateUnits().slice(15, 17) }
  };
  
  const area = allAreas[areaId];
  
  const generateSchedule = () => {
    const schedule = [];
    const today = new Date();
    
    for (let i = 0; i < 14; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      
      const dateStr = date.toLocaleDateString();
      const dayData = { date: dateStr };
      
      area.units.forEach((unit, index) => {
        // Randomly assign EMPTY or unit
        if (Math.random() < 0.2) {
          dayData[`slot${index}`] = 'EMPTY';
        } else {
          dayData[`slot${index}`] = unit;
        }
      });
      
      schedule.push(dayData);
    }
    
    return schedule;
  };
  
  const schedule = generateSchedule();
  
  if (!area) {
    return <Typography>Area not found</Typography>;
  }
  
  return (
    <div>
      <Typography variant="h4" gutterBottom>
        {area.name} - Schedule Details
      </Typography>
      
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              {area.units.map((unit, index) => (
                <TableCell key={index}>Slot {index + 1}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {schedule.map((day, dayIndex) => (
              <TableRow key={dayIndex}>
                <TableCell>{day.date}</TableCell>
                {area.units.map((unit, slotIndex) => (
                  <TableCell key={slotIndex}>
                    {day[`slot${slotIndex}`] === 'EMPTY' ? (
                      <Chip label="EMPTY" color="default" size="small" />
                    ) : (
                      (() => {
                        const { unitName, projectId } = parseUnitString(day[`slot${slotIndex}`]);
                        return (
                          <MuiLink 
                            component={Link}
                            to={`/projects/${projectId}/unit/${unitName}`}
                            sx={{ textDecoration: 'none' }}
                          >
                            <Chip label={day[`slot${slotIndex}`]} color="primary" size="small" sx={{ cursor: 'pointer' }} />
                          </MuiLink>
                        );
                      })()
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default AreaDetails;